import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ShimmerThumbnail } from "react-shimmer-effects";
import ReactImageGallery from "react-image-gallery";
import { useMediaQuery } from "@mui/material";

const Hero = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const isMobile = useMediaQuery("(max-width:575px)");

  const imageGalleryRef = useRef();

  const getData = async () => {
    setLoading(true);
    if (error) setError(false);
    await axios
      .get("get-banner")
      .then((res) => {
        let data = res?.data?.banner?.map((element) => ({
          ...element, // Spread the existing properties
          src: element?.url, // Add or override the `src` property
          id: element?._id, // Add or override the `id` property
        }));
        if (isMobile) {
          setBanners(data?.filter((banner) => banner?.ismobile));
        } else {
          setBanners(data?.filter((banner) => !banner?.ismobile));
        }
        // setBanners(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setError(true);
      });
  };

  useEffect(() => {
    getData();
  }, [isMobile]);

  return (
    <div className="home-banner-wrapper">
      {loading ? (
        <ShimmerThumbnail fitOnFrame className={"mb-0"} />
      ) : error ? (
        <div className="w-full h-full flex justify-center items-center flex-col">
          <h4>Oops Something Went Wrong </h4>
          <button className="btn btn-primary" onClick={getData}>
            Refresh
          </button>
        </div>
      ) : banners.length > 0 ? (
        <ReactImageGallery
          ref={imageGalleryRef}
          showPlayButton={false}
          autoPlay={true}
          items={banners?.map((image) => ({
            original: image?.url,
            thumbnail: image?.url,
          }))}
          slideDuration={600}
          showBullets={false}
          showThumbnails={false}
          showFullscreenButton={false}
          showNav={false}
          renderItem={(src) => {
            return <img src={src.original} alt={`home-banner-images-${src?.original}`} className="banner-image" />;
          }}
        />
      ) : null}
    </div>
  );
};

export default Hero;